module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid4_800x724.f14e84e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid4_800x724.jpg
// module id = 12C5
// module chunks = 0